import { render, staticRenderFns } from "./HeaderCredits.vue?vue&type=template&id=678de78c&scoped=true"
import script from "./HeaderCredits.vue?vue&type=script&lang=js"
export * from "./HeaderCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678de78c",
  null
  
)

export default component.exports